
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/community-affairs",
      function () {
        return require("private-next-pages/community-affairs.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/community-affairs"])
      });
    }
  